function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0036 29.0027C17.1171 29.0027 18.0198 28.1 18.0198 26.9865C18.0198 25.8729 17.1171 24.9702 16.0036 24.9702C14.89 24.9702 13.9873 25.8729 13.9873 26.9865C13.9873 28.1 14.89 29.0027 16.0036 29.0027Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7946 18.212L17.5706 18.2494V21.4604C17.5706 22.3192 16.8985 23.0286 16.0024 23.0286C15.1436 23.0286 14.4716 22.3192 14.4716 21.4604V16.8679C14.4716 16.0091 15.1436 15.2997 16.0024 15.2997C18.2054 15.2997 19.9602 13.5448 19.9602 11.3792C19.9602 9.17624 18.2054 7.42136 16.0024 7.42136C13.8368 7.42136 12.0819 9.17624 12.0819 11.3792C12.0819 12.238 11.3725 12.91 10.5137 12.91C9.65496 12.91 8.9082 12.2006 8.9082 11.3418C8.9082 9.17624 9.87899 7.19733 11.5592 5.81582C13.2021 4.47166 15.405 3.98626 17.5333 4.43432C20.0723 4.95705 22.2005 7.01064 22.8353 9.47495C23.8434 13.3581 21.6031 17.2412 17.7946 18.212Z"
});

function SvgInfoStall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoStall);
export default __webpack_public_path__ + "static/media/infoStall.962b6081.svg";
export { ForwardRef as ReactComponent };